import PhotoSwipeLightbox from './../../../../../../node_modules/photoswipe/dist/photoswipe-lightbox.esm';
import PhotoSwipe from './../../../../../../node_modules/photoswipe/dist/photoswipe.esm';
import Alpine from 'alpinejs';

Alpine.data('lightboxGallery', () => ({
    init() {
        let zoomIcon =
            '<svg class="text-white" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';
        let closeIcon =
            '<svg class="text-white" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
        let arrowPrevIcon =
            '<svg class="text-white" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
        let arrowNextIcon =
            '<svg class="text-white" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
        const lightbox = new PhotoSwipeLightbox({
            gallery: this.$root,
            children: 'a',
            showAnimationDuration: 500,
            hideAnimationDuration: 500,
            pswpModule: PhotoSwipe,
            maxZoomLevel: 1,
            wheelToZoom: false,
            counter: false,
            closeSVG: closeIcon,
            zoomSVG: zoomIcon,
            arrowPrevSVG: arrowPrevIcon,
            arrowNextSVG: arrowNextIcon,
        });

        // add bullets
        lightbox.on('uiRegister', function () {
            lightbox.pswp.ui.registerElement({
                name: 'bulletsIndicator',
                className: 'pswp__bullets-indicator',
                appendTo: 'wrapper',
                onInit: (el, pswp) => {
                    const bullets = [];
                    let bullet;
                    let prevIndex = -1;

                    for (let i = 0; i < pswp.getNumItems(); i++) {
                        bullet = document.createElement('div');
                        bullet.className = 'pswp__bullet';
                        bullet.onclick = (e) => {
                            pswp.goTo(bullets.indexOf(e.target));
                        };
                        el.appendChild(bullet);
                        bullets.push(bullet);
                    }

                    pswp.on('change', () => {
                        if (prevIndex >= 0) {
                            bullets[prevIndex].classList.remove('pswp__bullet--active');
                        }
                        bullets[pswp.currIndex].classList.add('pswp__bullet--active');
                        prevIndex = pswp.currIndex;
                    });
                },
            });
        });

        lightbox.init();
    },

    setPswpDimentions(url, el) {
        if (el.dataset.pswpWidth) return;

        let img = new Image();

        img.onload = () => {
            el.dataset.pswpWidth = img.width;
            el.dataset.pswpHeight = img.height;
        };

        img.src = url;
    },
}));
